(function () {
  var overlay     = document.getElementById('cta-modal-overlay');
  if (!overlay) return;

  var closeBtn    = document.getElementById('cta-modal-close');
  var reserveWrap = document.getElementById('cta-modal-reserve');
  var sourceWrap  = document.getElementById('cta-modal-source');
  var productInfo = document.getElementById('cta-modal-product-info');
  var typeLabel   = document.getElementById('cta-modal-type-label');
  var reserveBody = document.getElementById('reserve-body');
  var sourceBody  = document.getElementById('source-body');
  var reserveForm = document.getElementById('cta-reserve-form');
  var sourceForm  = document.getElementById('cta-source-form');

  var _openedAt = 0;

  /* ── Product-type-aware copy ─────────────────────────────────────────
     Was hardcoded to "Watch"/"timepiece" everywhere, including on bags and
     jewelry. Confirmed live 2026-09-22 on a Hermès Birkin ("Inquire This
     Watch") and a diamond ring ("WATCH ENQUIRY" modal, "this timepiece"
     body copy). Trigger buttons now pass data-product-type (see
     buy-buttons.liquid); "timepiece" is kept as the elevated word for
     watches specifically, matching the existing brand voice. */
  var _lastItemWord = 'timepiece';
  function itemWordFor(productType) {
    if (productType === 'Bag') return 'bag';
    if (productType === 'Piece') return 'piece';
    return 'timepiece';
  }

  /* ── Open modal ──────────────────────────────────────────────────── */
  function openModal(type, data) {
    /* Reset both wraps to original form state in case user re-opens */
    [reserveWrap, sourceWrap].forEach(function (w) {
      var saved = w.getAttribute('data-original-html');
      if (saved) w.innerHTML = saved;
      w.hidden = true;
      rewireForm(w);
    });

    /* Must be re-queried AFTER the innerHTML reset above, which replaces
       these nodes on every open — references grabbed once at page-load
       point at detached elements after the first reset, silently leaving
       the title/subtitle stuck on their static "Watch"/"timepiece"
       defaults. Confirmed 2026-09-22: typeLabel (outside the reset wraps)
       updated correctly while these (inside them) did not, which is what
       exposed the bug. */
    var reserveSubtitle = document.getElementById('cta-modal-reserve-subtitle');
    var sourceTitle      = document.getElementById('cta-modal-source-title');
    var sourceSubtitle   = document.getElementById('cta-modal-source-subtitle');

    var productName = (data.variant && data.variant !== 'Default Title')
      ? data.title + ' — ' + data.variant
      : data.title;

    var productType = data.productType || 'Watch';
    var itemWord = itemWordFor(productType);
    _lastItemWord = itemWord;

    productInfo.textContent = '';
    var nameEl = document.createElement('span');
    nameEl.className   = 'product-name';
    nameEl.textContent = productName;
    productInfo.appendChild(nameEl);
    if (data.price) {
      var priceEl = document.createElement('span');
      priceEl.className   = 'product-price';
      priceEl.textContent = data.price;
      productInfo.appendChild(priceEl);
    }

    _openedAt = Date.now();

    if (type === 'reserve') {
      typeLabel.textContent = 'Price on Request';
      reserveWrap.hidden    = false;
      if (reserveSubtitle) {
        reserveSubtitle.textContent =
          'Our team will contact you within 24 hours to arrange exclusive access to this ' + itemWord + '.';
      }
      document.getElementById('reserve-body').value =
        'Enquiry Type: Price on Request\n' +
        'Product: ' + productName + '\n' +
        (data.price ? 'Listed Price: ' + data.price + '\n' : '') +
        'Variant ID: ' + (data.variantId || '') + '\n' +
        'Page URL: ' + window.location.href + '\n\n' +
        'Customer message: (see below)';
    } else {
      typeLabel.textContent = productType + ' Enquiry';
      sourceWrap.hidden     = false;
      if (sourceTitle) sourceTitle.textContent = 'Enquire About This ' + productType;
      if (sourceSubtitle) {
        sourceSubtitle.textContent =
          'Our team will reach out to discuss pricing and availability for this ' + itemWord + '.';
      }
      document.getElementById('source-body').value =
        'Enquiry Type: ' + productType + ' Enquiry\n' +
        'Product: ' + productName + '\n' +
        'Variant ID: ' + (data.variantId || '') + '\n' +
        'Page URL: ' + window.location.href + '\n\n' +
        'Customer message: (see below)';
    }

    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ── Bot / spam protection ───────────────────────────────────────── */
  function isBotSubmission(form) {
    var hp      = form.querySelector('[name="contact[url]"]');
    var elapsed = Date.now() - _openedAt;
    return (hp && hp.value !== '') || elapsed < 2000;
  }

  /* ── Loading state ───────────────────────────────────────────────── */
  function setLoading(btn, loading, label) {
    if (!btn) return;
    btn.disabled = loading;
    btn.style.opacity = loading ? '0.7' : '';
    var span = btn.querySelector('span');
    if (span) span.textContent = loading ? 'Sending…' : label;
    var icon = btn.querySelector('svg');
    if (icon) icon.style.display = loading ? 'none' : '';
  }

  /* ── Success state (replaces form content) ───────────────────────── */
  function showSuccess(wrap) {
    wrap.innerHTML =
      '<div class="cta-success">' +
        '<div class="cta-success__icon">' +
          '<svg width="52" height="52" viewBox="0 0 52 52" fill="none">' +
            '<circle cx="26" cy="26" r="25" stroke="#c8a64a" stroke-width="1"/>' +
            '<path d="M15 26L22 33L37 18" stroke="#c8a64a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</div>' +
        '<h3 class="cta-success__title">Request Received</h3>' +
        '<p class="cta-success__msg">Our team will reach out within 24 hours to assist you with this ' + _lastItemWord + '.</p>' +
        '<button class="cta-success__close">Close</button>' +
      '</div>';
    wrap.querySelector('.cta-success__close').addEventListener('click', closeModal);
  }

  /* ── Error state (inline, above submit button) ───────────────────── */
  function showError(form, btn, originalLabel) {
    setLoading(btn, false, originalLabel);
    var existing = form.querySelector('.cta-modal__error');
    if (existing) existing.remove();
    var err = document.createElement('p');
    err.className   = 'cta-modal__error';
    err.textContent = 'Something went wrong. Please try again or reach us on WhatsApp.';
    var submitBtn = form.querySelector('.cta-modal__submit');
    if (submitBtn) form.insertBefore(err, submitBtn);
    else form.appendChild(err);
  }

  /* ── Make.com webhook (fire-and-forget) ──────────────────────────── */
  function fireWebhook(type, form) {
    try {
      var payload;
      if (type === 'reserve') {
        var bodyVal = form.querySelector('[name="contact[body]"]');
        var priceLine = bodyVal ? (bodyVal.value.match(/Listed Price: ([^\n]+)/) || [])[1] || '' : '';
        var prodLine  = bodyVal ? (bodyVal.value.split('\n')[1] || '').replace('Product: ', '') : '';
        payload = {
          enquiry_type: 'request-access',
          product:  prodLine,
          price:    priceLine,
          name:     (form.querySelector('[name="contact[name]"]')  || {}).value || '',
          email:    (form.querySelector('[name="contact[email]"]') || {}).value || '',
          phone:    (form.querySelector('[name="contact[phone]"]') || {}).value || '',
          message:  (form.querySelector('[name="contact[message_extra]"]') || {}).value || '',
          page_url: window.location.href
        };
      } else {
        var bodyVal = form.querySelector('[name="contact[body]"]');
        var prodLine = bodyVal ? (bodyVal.value.split('\n')[1] || '').replace('Product: ', '') : '';
        payload = {
          enquiry_type: 'request-price',
          product:  prodLine,
          name:     (form.querySelector('[name="contact[name]"]')  || {}).value || '',
          email:    (form.querySelector('[name="contact[email]"]') || {}).value || '',
          phone:    (form.querySelector('[name="contact[phone]"]') || {}).value || '',
          message:  (form.querySelector('[name="contact[message_extra]"]') || {}).value || '',
          page_url: window.location.href
        };
      }
      fetch('https://hook.eu2.make.com/l7lm1uoeuux73f834wnrp3rdrikp3wb1', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function () {});
    } catch (e) {}
  }

  /* ── Core submit handler ─────────────────────────────────────────── */
  function handleSubmit(e, form, type, wrap) {
    e.preventDefault();
    if (isBotSubmission(form)) return;

    var originalLabel = 'Send Enquiry';
    var btn = form.querySelector('.cta-modal__submit');

    /* Ensure URL and merge customer message into body before sending */
    var bodyEl = form.querySelector('[name="contact[body]"]');
    if (bodyEl) {
      if (!bodyEl.value.includes('Page URL:')) {
        bodyEl.value += '\nPage URL: ' + window.location.href;
      }
      if (type === 'reserve') {
        var msg = (form.querySelector('#reserve-message') || {}).value || '';
        if (msg) bodyEl.value = bodyEl.value.replace('(see below)', msg);
      } else {
        var msg = (form.querySelector('#source-message') || {}).value || '';
        if (msg) bodyEl.value = bodyEl.value.replace('(see below)', msg);
      }
    }

    /* Prepend country code to phone number */
    var phoneInput = form.querySelector('[name="contact[phone]"]');
    if (phoneInput) {
      var codeSelect = form.querySelector('.cta-modal__phone-code');
      var code = codeSelect ? codeSelect.value.trim() : '';
      var num = phoneInput.value.trim();
      if (code && num && !num.startsWith('+')) {
        phoneInput.value = code + ' ' + num;
      }
    }

    setLoading(btn, true, originalLabel);
    fireWebhook(type, form);

    /* The customer's message was already merged into contact[body] above;
       clear message_extra so it isn't submitted a second time under its
       own field (Shopify's contact notification lists every field, so an
       unmerged duplicate showed up as both "Customer message" and
       "Message Extra" with identical text). */
    var msgField = form.querySelector('[name="contact[message_extra]"]');
    if (msgField) msgField.value = '';

    /* Submit to Shopify /contact via fetch */
    fetch('/contact', {
      method:  'POST',
      headers: {
        'Content-Type':     'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new URLSearchParams(new FormData(form)).toString()
    })
    .then(function (res) {
      if (res.ok) {
        showSuccess(wrap);
      } else {
        showError(form, btn, originalLabel);
      }
    })
    .catch(function () {
      showError(form, btn, originalLabel);
    });
  }

  /* ── Wire up form event listeners ────────────────────────────────── */
  function rewireForm(wrap) {
    var form = wrap.querySelector('form');
    if (!form) return;
    var type = form.id === 'cta-reserve-form' ? 'reserve' : 'source';
    form.addEventListener('submit', function (e) {
      handleSubmit(e, form, type, wrap);
    });
  }

  /* Save original HTML so we can restore on re-open */
  reserveWrap.setAttribute('data-original-html', reserveWrap.innerHTML);
  sourceWrap.setAttribute('data-original-html',  sourceWrap.innerHTML);
  rewireForm(reserveWrap);
  rewireForm(sourceWrap);

  /* ── Close handlers ──────────────────────────────────────────────── */
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  /* ── Open on trigger click ───────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cta-modal]');
    if (!trigger) return;
    e.preventDefault();
    openModal(trigger.dataset.ctaModal, {
      title:       trigger.dataset.productTitle || '',
      variant:     trigger.dataset.variantTitle || '',
      price:       trigger.dataset.price        || '',
      variantId:   trigger.dataset.variantId    || '',
      productType: trigger.dataset.productType  || 'Watch'
    });
  });
})();
